const MaskRules: any = {
    phone: '+1 ### ### ####'
};

MaskRules.install = (Vue, options) => {
    Vue.prototype.$masks = MaskRules
}

export default MaskRules
